import { styled } from '@mui/material';

interface DropAreaProps {
  disabled?: boolean;
  isDragActive?: boolean;
  isDragAccept?: boolean;
  isDragReject?: boolean;
}

const forwardProp: Record<string, boolean> = {
  isDragActive: true,
  isDragAccept: true,
  isDragReject: true,
};

export const DropArea = styled('div', {
  shouldForwardProp: (prop) => !forwardProp[String(prop)],
})<DropAreaProps>(({ theme, isDragAccept, isDragReject, isDragActive }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(3),
  borderWidth: 2,
  borderRadius: 10,
  borderColor: theme.palette.grey[200],
  borderStyle: 'dashed',
  outline: 'none',
  transition: theme.transitions.create(['border'], {
    duration: theme.transitions.duration.standard,
    easing: theme.transitions.easing.easeInOut,
  }),
  ...(isDragActive && {
    borderColor: theme.palette.action.active,
    '& > *': {
      pointerEvents: 'none',
    },
  }),
  ...(isDragAccept && {
    borderColor: theme.palette.success.main,
  }),
  ...(isDragReject && {
    borderColor: theme.palette.error.main,
  }),
}));
